import Image from "next/image";

import bgMobile from "@/assets/img/security/bg_mobile_app_download.svg";
import bg from "@/assets/img/security/lines_graph_cell.svg";
import { Container } from "@/components/Container";
import { Box, Stack, Typography } from "@mui/material";

import { SecurityInfoCellphoneProps } from "./types";

export const SecurityInfoCellphone: React.FC<SecurityInfoCellphoneProps> = ({ securityAppTitle, securityAppDescription }) => {
  return (
    <Stack minHeight={{ md: "50vh", lg: "60vh", xl: "74vh" }} position="relative" mt={{ md: "118px" }}>
      <Box display={{ xs: "none", md: "inherit" }} position="absolute" width="100%">
        <Image src={bg} alt="Aplicativo de segurança aberto na tela inicial" style={{ width: "100%", height: "auto" }} />
      </Box>

      <Box display={{ xs: "inherit", md: "none" }} position="relative" width="100%" mt="51px">
        <Image src={bgMobile} alt="Aplicativo de segurança aberto na tela inicial" style={{ width: "100%", height: "auto" }} />
      </Box>

      <Container pt={{ xs: 4.5, sm: 4.5, md: 20 }} px={{ xs: "24px", sm: "24px", md: "84px", lg: "81px" }}>
        <Stack maxWidth={{ md: "30rem", lg: "35rem" }} zIndex={2} position="relative" spacing={2}>
          <Typography fontSize={32} fontWeight={600}>
            {securityAppTitle}
          </Typography>

          <Typography color="#58595B" width="85%" whiteSpace="pre-line">
            {securityAppDescription}
          </Typography>
        </Stack>
      </Container>
    </Stack>
  );
};
